import { createDirectus, rest, createItem, readItem, readItems, readCollection, readSingleton } from '@directus/sdk'
// authentication, customEndpoint, graphql, readUsers, etc.
// https://docs.directus.io/reference/introduction.html

export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	const directus = createDirectus(config.public.backBase).with(rest())

	return {
		provide: {
			directus,
			createItem,
			readItem,
			readItems,
			readCollection,
			readSingleton
		}
	}
})